import React, { Component } from 'react';
import PropTypes from 'prop-types';

import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import { Button, CircularProgress, Typography } from '@material-ui/core';

import '../assets/stylesheets/Dropzone.css';
import i18n from '../i18n';

class Dropzone extends Component {
  constructor(props) {
    super(props);
    this.state = {
      highlight: false
    };
    this.imageInputRef = React.createRef();
  }

  onImageAdded = event => {
    const { disabled, onFileAdded } = this.props;
    if (!disabled) {
      const image = event.target.files[0];
      onFileAdded(image);
    }
  };

  openFileDialog = () => {
    const { disabled } = this.props;
    if (!disabled) {
      this.imageInputRef.current.click();
    }
  };

  onDragOver = event => {
    const { disabled } = this.props;
    event.preventDefault();
    if (!disabled) {
      this.setState({ highlight: true });
    }
  };

  onDragLeave = () => {
    this.setState({ highlight: false });
  };

  onDrop = event => {
    const { disabled, onFileAdded } = this.props;
    event.preventDefault();

    if (!disabled) {
      const image = event.dataTransfer.files[0];
      onFileAdded(image);
    }
    this.setState({ highlight: false });
  };

  render() {
    const { loading, profileImage, disabled } = this.props;
    const { highlight } = this.state;

    if (loading) {
      return (
        <div className="profileContainer">
          <CircularProgress color="secondary" />
          <Typography variant="body1">{i18n.t('loading')}</Typography>
        </div>
      );
    }

    return (
      <div className="profileContainer">
        <div
          onDragOver={this.onDragOver}
          onDragLeave={this.onDragLeave}
          onDrop={this.onDrop}
          role="button"
          tabIndex="0"
          onClick={this.openFileDialog}
          onKeyDown={this.openFileDialog}
        >
          {profileImage ? (
            <img className="profilePic" alt="Profile Pic" src={profileImage} />
          ) : (
            <CloudUploadIcon
              className={`dropzoneIcon ${highlight ? 'highlight' : ''}`}
            />
          )}
        </div>

        <Button onClick={this.openFileDialog} disabled={disabled}>
          {i18n.t('selectImage')}
        </Button>
        <input
          ref={this.imageInputRef}
          className="imageInput"
          type="file"
          onChange={this.onImageAdded}
        />
      </div>
    );
  }
}

Dropzone.defaultProps = {
  profileImage: null
}

Dropzone.propTypes = {
  onFileAdded: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  profileImage: PropTypes.string,
  loading: PropTypes.bool.isRequired,
};

export default Dropzone;
